import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  defaultLanguage = { name: 'English', icon: '/assets/images/plagiarism checker1/language.svg', code: 'en' };

  languages = [
    this.defaultLanguage,
  
    // { name: 'French', icon: '/assets/images/flag/French.svg', code: 'fr' },
    // { name: 'German', icon: '/assets/images/flag/german.svg', code: 'de' },
    { name: 'Portuguese', icon: '/assets/images/flag/Portuguese.svg', code: 'pt' },
      { name: 'Español', icon: '/assets/images/flag/espanol.svg', code: 'es' },
    // { name: 'Russian', icon: '/assets/images/flag/Russian.svg', code: 'ru' },
    // { name: 'Italian', icon: '/assets/images/flag/Italian.svg', code: 'it' },
  ];

  private selectedLanguageSubject = new BehaviorSubject<any>(this.getStoredLanguage());
  selectedLanguage$ = this.selectedLanguageSubject.asObservable();

  // Use this getter to access the current selected language
  get selectedLanguage() {
    return this.selectedLanguageSubject.value;
  }

  constructor() {}

  setLanguage(language: any) {
    this.selectedLanguageSubject.next(language);
    localStorage.setItem('selectedLanguage', JSON.stringify(language));
  }

  // getStoredLanguage() {
  //   const stored = localStorage.getItem('selectedLanguage');
  //   try {
  //     const parsed = stored ? JSON.parse(stored) : this.defaultLanguage;
  //     return this.languages.find(lang => lang.code === parsed.code) || this.defaultLanguage;
  //   } catch (e) {
  //     console.warn('Invalid language in localStorage, resetting to default');
  //     localStorage.removeItem('selectedLanguage');
  //     return this.defaultLanguage;
  //   }
  // }

  getStoredLanguage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return this.defaultLanguage;
  }

  const stored = localStorage.getItem('selectedLanguage');
  try {
    const parsed = stored ? JSON.parse(stored) : this.defaultLanguage;
    return this.languages.find(lang => lang.code === parsed.code) || this.defaultLanguage;
  } catch (e) {
    console.warn('Invalid language in localStorage, resetting to default');
    localStorage.removeItem('selectedLanguage');
    return this.defaultLanguage;
  }
}


  private dropdownVisible = new BehaviorSubject<boolean>(false);
  isDropdownVisible$ = this.dropdownVisible.asObservable();

  showDropdown() {
    this.dropdownVisible.next(true);
  }

  hideDropdown() {
    this.dropdownVisible.next(false);
  }

  
 getLanguageFromUrl(url: string): string {
  const langCode = url.split('/')[1];
  const match = this.languages.find(lang => lang.code === langCode);
  return match ? match.code : this.defaultLanguage.code;
}
getLocalizedImagePath(imageBaseName: string): string {

  const lang = this.selectedLanguage?.code || 'en';
  if (lang === 'en') {
    return `/assets/images/illustration/${imageBaseName}.svg`;
  } else {
    return `/assets/images/illustration/${imageBaseName}-${lang}.svg`;
  }
    
}


}